import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import { Table as ReactstrapTable } from 'reactstrap';
import TopRow from './TopRow';
import TableRow from './TableRow';
import TotalsRow from './TotalTr';
import { formatCurrency } from '../../lib/helpers/formatters';

function DashboardTable({ data = {}, year, history, totals }) {
  const {
    subscriptions = [],
    masters = [],
    masterShares = {},
    adminShare = {},
    insuranceAdminShare = {},
    gabettiPerc = {},
    detailTotals = {},
    studioVariableRevenues = {},
    insuranceMasterShares = {},
    insuranceGabettiPerc = {},
    contractsMasterShares = {},
    contractsAdminShare = {},
    detailTotalsContracts = {},
    contractsRecurrencyMasterShares = {},
    detailTotalsRecurringContracts = {},
    contractsRecurrencyAdminShare = {},
    signalsMasterShares = {},
    signalsGabettiPerc = {},
    signalsAdminShare = {},
    detailTotalsSignals = {},
    bottomRow = {},
  } = data;

  const [openRows, setOpenRows] = useState({});

  const toggleDetail = (key) => {
    setOpenRows((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const renderDetailRow = (rowData, key) => {
    return (
      <tr>
        <td colSpan={5} style={{ background: '#f9f9f9' }}>
          <table style={{ width: '100%' }}>
            <tbody>
              <tr>
                <td>Dettaglio dovuto:</td>
                <td>Amministratori: {formatCurrency(rowData.admin)}</td>
                {key !== 'signals' && (
                  <td>Agenzie: {formatCurrency(rowData.agency)}</td>
                )}
                {key !== 'signals' && (
                  <td>Commerciali: {formatCurrency(rowData.commercial)}</td>
                )}
                {/* {key !== 'signals' && (
                  <td>Utilizzatori: {formatCurrency(rowData.utilizer)}</td>
                )} */}
                {key !== 'signals' && (
                  <td>Associazioni: {formatCurrency(rowData.association)}</td>
                )}
              </tr>
            </tbody>
          </table>
        </td>
      </tr>
    );
  };

  return (
    <ReactstrapTable responsive hover className="data-table">
      <thead>
        <tr>
          <th />
          <th />
          <th>Imponibile totale</th>
          <th>Dovuto</th>
          <th>EC/Banca</th>
        </tr>
      </thead>
      <tbody>
        <TopRow totals={totals} />

        {subscriptions.map(
          ({ type, title = '', total = 0, cashed = 0 }, index) => (
            <tr
              key={index}
              onClick={() => history.push(`/dashboard/${type}?year=${year}`)}
            >
              <td />
              <td className="title">{title}</td>
              <td className="txt-table-right">-</td>
              <td className="txt-table-right">{formatCurrency(total)}</td>
              <td className="txt-table-right">{formatCurrency(cashed)}</td>
            </tr>
          )
        )}

        <TableRow data={masters} />
        <tr
          onClick={({ perc }) =>
            history.push(`/dashboard/compensi-studio?year=${year}`)
          }
        >
          <td />
          <td className="title">
            Compensi variabili da fatture studio (1000€ o 1%)
          </td>
          <td className="txt-table-right">-</td>
          <td className="txt-table-right">
            <strong>{formatCurrency(studioVariableRevenues.total || 0)}</strong>
          </td>
          <td className="txt-table-right">
            <strong>
              {formatCurrency(studioVariableRevenues.cashed || 0)}
            </strong>
          </td>
        </tr>

        <TableRow
          data={masters}
          onClick={({ perc }) =>
            history.push(`/dashboard/masters?percentage=${perc}&year=${year}`)
          }
        />

        <React.Fragment>
          <tr
            onClick={(e) => {
              if (e.target.closest('.arrow-cell')) return;
              history.push(`/dashboard/compensi?year=${year}`);
            }}
          >
            <td
              className="arrow-cell"
              style={{ cursor: 'pointer', width: 40, textAlign: 'center' }}
              onClick={(e) => {
                e.stopPropagation();
                toggleDetail('invoices');
              }}
            >
              {openRows['invoices'] ? (
                <i class="fas fa-chevron-down"></i>
              ) : (
                <i class="fas fa-chevron-right"></i>
              )}
            </td>
            <td className="title">Compensi variabili da fatture (% Extra)</td>
            <td className="txt-table-right">
              {formatCurrency(gabettiPerc.net || 0)}
            </td>
            <td className="txt-table-right">
              <strong>{formatCurrency(gabettiPerc.total || 0)}</strong>
            </td>
            <td className="txt-table-right">
              <strong>{formatCurrency(gabettiPerc.cashed || 0)}</strong>
            </td>
          </tr>
          {openRows['invoices'] && renderDetailRow(detailTotals)}
        </React.Fragment>

        <React.Fragment>
          <tr
            onClick={(e) => {
              if (e.target.closest('.arrow-cell')) return;
              history.push(`/contracts-resume?year=${year}`);
            }}
          >
            <td
              className="arrow-cell"
              style={{ cursor: 'pointer', width: 40, textAlign: 'center' }}
              onClick={(e) => {
                e.stopPropagation();
                toggleDetail('fee');
              }}
            >
              {openRows['fee'] ? (
                <i class="fas fa-chevron-down"></i>
              ) : (
                <i class="fas fa-chevron-right"></i>
              )}
            </td>
            <td className="title">Compensi fornitori energia</td>
            <td className="txt-table-right">
              {formatCurrency(
                (contractsMasterShares.total || 0) +
                  (contractsAdminShare.total || 0)
              )}
            </td>
            <td className="txt-table-right">
              <strong>
                {formatCurrency(contractsMasterShares.total || 0)}
              </strong>
            </td>
            <td className="txt-table-right">
              <strong>
                {formatCurrency(contractsMasterShares.cashed || 0)}
              </strong>
            </td>
          </tr>
          {openRows['fee'] && renderDetailRow(detailTotalsContracts)}
        </React.Fragment>

        <React.Fragment>
          <tr
            onClick={(e) => {
              if (e.target.closest('.arrow-cell')) return;
              history.push(`/contracts-recurrency-resume?year=${year}`);
            }}
          >
            <td
              className="arrow-cell"
              style={{ cursor: 'pointer', width: 40, textAlign: 'center' }}
              onClick={(e) => {
                e.stopPropagation();
                toggleDetail('recurringFee');
              }}
            >
              {openRows['recurringFee'] ? (
                <i class="fas fa-chevron-down"></i>
              ) : (
                <i class="fas fa-chevron-right"></i>
              )}
            </td>
            <td className="title">Ricorrenze fornitori energia</td>
            <td className="txt-table-right">
              {formatCurrency(
                (contractsRecurrencyMasterShares.total || 0) +
                  (contractsRecurrencyAdminShare.total || 0)
              )}
            </td>
            <td className="txt-table-right">
              <strong>
                {formatCurrency(contractsRecurrencyMasterShares.total || 0)}
              </strong>
            </td>
            <td className="txt-table-right">
              <strong>
                {formatCurrency(contractsRecurrencyMasterShares.cashed || 0)}
              </strong>
            </td>
          </tr>
          {openRows['recurringFee'] &&
            renderDetailRow(detailTotalsRecurringContracts)}
        </React.Fragment>

        <React.Fragment>
          <tr
            onClick={(e) => {
              if (e.target.closest('.arrow-cell')) return;
              history.push(`/signals-resume?year=${year}`);
            }}
          >
            <td
              className="arrow-cell"
              style={{ width: 40, textAlign: 'center' }}
              onClick={(e) => {
                e.stopPropagation();
                // toggleDetail('signals');
              }}
            >
              {/* {openRows['signals'] ? (
                <i class="fas fa-chevron-down"></i>
              ) : (
                <i class="fas fa-chevron-right"></i>
              )} */}
              -
            </td>
            <td className="title">Segnalazioni</td>
            <td className="txt-table-right">
              {formatCurrency(signalsGabettiPerc.net || 0)}
            </td>
            <td className="txt-table-right">
              <strong>{formatCurrency(signalsGabettiPerc.total || 0)}</strong>
            </td>
            <td className="txt-table-right">
              <strong>{formatCurrency(signalsGabettiPerc.cashed || 0)}</strong>
            </td>
          </tr>
          {/* {openRows['signals'] &&
            renderDetailRow(detailTotalsSignals, 'signals')} */}
        </React.Fragment>

        <TotalsRow totals={totals} />
      </tbody>
    </ReactstrapTable>
  );
}

export default withRouter(DashboardTable);
